export default [
  {
    path:'/admin/jiugong/config',
    name:'JiugongConfig',
    component:()=>import('@/views/Jiugong/config'),
    meta:{
      title:'抽奖设置'
    }
  },
  {
    path:'/admin/jiugong/list',
    name: 'JiugongList',
    component:()=>import('@/views/Jiugong/list'),
    meta:{
      tiitle:'奖品列表'
    }
  },
  {
    path:'/admin/jiugong/order',
    name: 'JiugongOrder',
    component:()=>import('@/views/Jiugong/order'),
    meta: {
      title: '赠品订单'
    }
  },
  {
    path:'/admin/jiugong/edit',
    name: 'JiugongEdit',
    component:()=>import('@/views/Jiugong/edit'),
    meta: {
      title: '新增/编辑抽奖活动'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/jiugong.js